import React, { useState } from 'react';

import { SavingsBadge } from '../../../components/certificate-card/components';
import { getCertificateImageSrc } from '../../../components/certificate-card/utils';

import type { DetailHeroProps } from './types';

import styles from './styles.module.scss';

export const DetailHero: React.FC<DetailHeroProps> = ({
  imageUrl,
  fallbackUrl,
  savingsPercent,
}) => {
  const [imageError, setImageError] = useState(false);
  const imageSrc = getCertificateImageSrc(imageUrl ?? fallbackUrl ?? null, imageError);

  return (
    <div className={styles.heroWrap}>
      <img
        src={imageSrc}
        alt=""
        className={styles.heroImage}
        loading="eager"
        onError={() => setImageError(true)}
      />
      {savingsPercent > 0 && <SavingsBadge amount={savingsPercent} />}
    </div>
  );
};
